<script>
  import Close from "./svg/Close.svelte";
  import Chevron from "./svg/Chevron.svelte";
  export let open = false;
</script>

<button on:click>
  {#if open}
    <Close />
  {:else}
    <Chevron />
  {/if}
</button>

<style>
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
    border-left: 1px solid black;
    border-radius: 0;
    width: 42px;
    box-sizing: border-box;
    height: 100%;
  }
  /* img {
    padding: 0px;
    box-sizing: border-box;
    width: 100%;
    height: auto;
  } */
</style>
